import React, { FC, useMemo } from 'react'
import { useReapitConnect } from '@reapit/connect-session'
import { reapitConnectBrowserSession } from '../../../core/connect-session'
import { NavResponsive, NavResponsiveOption } from '@reapit/elements'
import { useLocation } from 'react-router-dom'
import { Routes } from '../../../constants/routes'
import { history } from '../../../core/router'
import { navigate } from '../../../utils/navigation'
// import { css } from '@linaria/core'

export const Nav: FC = () => {
  const location = useLocation()
  const { connectLogoutRedirect, connectIsDesktop } = useReapitConnect(reapitConnectBrowserSession)
  const defaultNavIndex = useMemo(() => {
    let index = 0
    switch (location.pathname) {
      case Routes.HOME:
      case Routes.ENVELOPES:
        index = 1
        break
      case Routes.TEMPLATES:
        index = 3
        break
      default:
        if (location.pathname.includes('envelopes')) {
          index = 1
        } else if (location.pathname.includes('prepare-template')) {
          index = 3
        } else index = 0
        break
    }
    return index
  }, [location.pathname])
  const navOptions: NavResponsiveOption[] = [
    {
      itemIndex: 0,
      callback: navigate(history, Routes.ENVELOPES),
    },
    {
      itemIndex: 1,
      text: 'Envelopes',
      iconId: 'defaultMenu',
      callback: navigate(history, Routes.ENVELOPES),
    },
    {
      itemIndex: 3,
      href: Routes.TEMPLATES,
      iconId: 'docsMenu',
      text: 'Templates',
      callback: navigate(history, Routes.TEMPLATES),
    },
  ]

  if (!connectIsDesktop) {
    navOptions.push({
      itemIndex: 5,
      callback: connectLogoutRedirect,
      isSecondary: true,
      iconId: 'logoutMenu',
      text: 'Logout',
    })
  }
  // add key prop to force re-render default item
  return <NavResponsive options={navOptions} defaultNavIndex={defaultNavIndex} key={defaultNavIndex} />
}

export default Nav
